exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxContent__checkboxGroup___3-xxs {\n  width: 100%;\n  margin-top: -10px;\n  display: block; }\n  .CheckboxContent__checkboxGroup___3-xxs > div {\n    align-items: baseline; }\n\n.CheckboxContent__checkboxWrapper___2sDQ0 {\n  width: 100%;\n  height: auto;\n  margin-top: 10px; }\n", ""]);

// exports
exports.locals = {
	"checkboxGroup": "CheckboxContent__checkboxGroup___3-xxs",
	"checkboxWrapper": "CheckboxContent__checkboxWrapper___2sDQ0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/MultiSelector/CheckboxContent/CheckboxContent.scss
// module id = 2137
// module chunks = 6